<script setup lang="ts">
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

defineProps<{
  text: string;
}>();
</script>
<template>
  <div class="warning-note">
    <svg-illustration class="warning-note__icon" name="alert-triangle.svg"/>
    {{ text }}
  </div>
</template>
<style scoped lang="scss">
.warning-note {
  display: flex;
  gap: var(--Spacing-spacing-3);
  align-items: center;
  margin: 0;
  padding: var(--Spacing-spacing-3) var(--Spacing-spacing-4);
  border: 2px solid var(--Primary-primary-color-4);
  border-radius: 8px;
  // The token is the border; the fill is the same amber as a wash over the card surface.
  background: color-mix(in srgb, var(--Primary-primary-color-4) 15%, var(--Neutral-UI-neutral-ui-0));
  color: var(--Neutral-UI-neutral-ui-100);

  @include font-body-sm;
}

.warning-note__icon {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
}
</style>
